export default __webpack_public_path__ + "static/media/PL.025ec044.svg";